module.exports = __webpack_public_path__ + "img/1432252336.92390d2c.jpg";